"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayToObject = arrayToObject;
exports.haveSameElements = haveSameElements;
function arrayToObject({ arr, keyModifier = (elem) => elem, valueModifier = (elem) => elem, }) {
    return arr.reduce((acc, elem, index) => {
        acc[keyModifier(elem, index)] = valueModifier(elem, index);
        return acc;
    }, {});
}
function haveSameElements(arr1, arr2) {
    if (arr1.length !== arr2.length) {
        return false;
    }
    const map1 = new Map();
    const map2 = new Map();
    arr1.forEach((elem) => {
        map1.set(elem, (map1.get(elem) || 0) + 1);
    });
    arr2.forEach((elem) => {
        map2.set(elem, (map2.get(elem) || 0) + 1);
    });
    return map1.size === map2.size && Array.from(map1.entries()).every(([key, value]) => map2.get(key) === value);
}
